export function disclosureofConfidentialInformationSellerCB() {
return [   // Release 2025-12-17 08:35:49
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
] }
